import useErrorBoundary from 'use-error-boundary'

import { Icon } from 'components/ui'
import { errorParser } from 'utils/errors'

import { VerificationsTable } from './VerificationsTable'

import { KycVerificationTableProps } from '../types'
import { ErrorContent, ErrorWrapper, ErrorTitle, ErrorIcon, Subtitle } from '../Style'

function VerificationsTableWrapper(props: KycVerificationTableProps) {
  const { ErrorBoundary, didCatch, error } = useErrorBoundary()

  return didCatch ? (
    <ErrorWrapper>
      <ErrorTitle>Oops!</ErrorTitle>
      <ErrorIcon>
        <Icon name='skull' size='xl' />
      </ErrorIcon>
      <Subtitle>Something went wrong</Subtitle>
      <ErrorContent>{errorParser(error.toString())}</ErrorContent>
    </ErrorWrapper>
  ) : (
    <ErrorBoundary>
      <VerificationsTable {...props} />
    </ErrorBoundary>
  )
}

export { VerificationsTableWrapper as VerificationsTable }
